import { Button, styled } from "@mui/material"
import React from "react"

interface ScheduleMeetingDialogSingleBottomButtonProps {
  label: string
  onClick: () => void
}

const ScheduleMeetingDialogSingleBottomButton = (
  props: ScheduleMeetingDialogSingleBottomButtonProps,
) => {
  const { label, onClick } = props
  return (
    <_Button onClick={onClick} color="primary" variant="contained">
      {label}
    </_Button>
  )
}

export default ScheduleMeetingDialogSingleBottomButton

const _Button = styled(Button)({
  width: "100%",
  height: 50,
  marginTop: "auto",
  borderRadius: 0,
  padding: "9px 10px",
})
